const KEY = 'client_selected_this_session';

/** True once the user has explicitly picked a client in this browser tab. */
export function hasChosenClientThisSession(): boolean {
  if (typeof window === 'undefined') return false;
  return sessionStorage.getItem(KEY) === '1';
}

export function markClientChosen(): void {
  if (typeof window === 'undefined') return;
  sessionStorage.setItem(KEY, '1');
}

export function clearClientChosen(): void {
  if (typeof window === 'undefined') return;
  sessionStorage.removeItem(KEY);
}